
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import PasswordInput from "../input/PasswordInput";
import {useContext, useEffect, useState} from "react";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";
import {ValidationContext} from "../contexts/ValidationContext";
import DefaultButton from "../buttons/DefaultButton";
import CheckBoxInput from "../input/CheckBoxInput";

function EditUserModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        rowData: any
    }
) {
    const {Url } = useContext(ApiContext)
    const [ID,setID] = useState('')
    const [FirstName, setFirstName] = useState('')
    const [LastName, setLastName] = useState('')
    const [Email, setEmail] = useState('')
    const [Phone, setPhone] = useState('')
    const [Password, setPassword] = useState('')
    const [message, setMessage] = useState('')
    const [deleteConfirm, setDeleteConfirm] = useState(false)
    const [adminRole, setAdminRol] = useState(false)
    const { token } = useAuth();
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)

    function sendResetMail(event: React.FormEvent) {
        event.preventDefault()
        setMessage('Bezig met het versturen van de mail...')
        fetch(Url + 'password/reset-request', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                email: Email.toLowerCase()
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.message === 'Password reset requested') {
                    setMessage('Mail is succesvol verstuurd!')
                } else {
                    setMessage('Fout bij het versturen van de mail: ' + (data.message || 'Onbekende fout'))
                }
            })
            .catch(() => {
                setMessage('Er is een fout opgetreden bij het verbinden met de server.')
            })
    }

    function editUser(event: React.FormEvent) {
        event.preventDefault()
        //Api excepts an array, create one. Role with ID 1 is always admin
        let roleArray: number[]
        if (adminRole){
            roleArray = [1]
        }else{
            roleArray = []
        }
        fetch(Url + 'admin/users', {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: ID,
                FirstName: FirstName,
                LastName: LastName,
                Email: Email,
                Phone: Phone,
                Password: Password,
                Roles: roleArray
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    setPassword('')
                }
                return res.json()
            })
            .then((data) => {
                setMessage(data.message)
            })
    }

    useEffect(() => {
        if (!props.rowData) return;
        setFirstName(props.rowData.FirstName)
        setLastName(props.rowData.LastName)
        setEmail(props.rowData.Email)
        setPhone(props.rowData.Phone)
        setID(props.rowData.ID)

        if (props.rowData.Admin === "YES"){
            setAdminRol(true)
        }else{
            setAdminRol(false)
        }

    }, [props.rowData]);

    function handleClose(){
        setMessage('')
        setFirstName('')
        setLastName('')
        setPassword('')
        setEmail('')
        setPhone('')
        setPassword('')
        setAdminRol(false)
        props.setOpenModal(false)
    }
    function deleteUser(event: React.FormEvent){
        event.preventDefault()
        setDeleteConfirm(false)
        fetch(Url + 'admin/users', {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: ID,
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    setPassword('')
                }
                return res.json()
            })
            .finally(() =>
                props.setOpenModal(false)
            )
    }
    return (
        <BaseModal
            show={props.openModal}
            onClose={handleClose}
            title={`Bewerk gebruiker (ID:${ID}) - ${FirstName} ${LastName}`}
            footer={
                <>
                    <DefaultButton onClick={editUser} content="Wijzigen" />
                    <DefaultButton onClick={sendResetMail} content="Stuur Mail" />
                    <DefaultButton onClick={() => setDeleteConfirm(true)} content="Verwijderen" />
                    <DefaultButton onClick={handleClose} content="Sluiten" />
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Bewerk de gegevens en klik op wijzigen
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput
                labelName="Voornaam"
                inputName="FirstName"
                value={FirstName}
                placeholder="Voornaam"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
                onChange={(e) => setFirstName(e.target.value)}
            />
            <TextInput
                labelName="Achternaam"
                inputName="lastName"
                onChange={(e) => setLastName(e.target.value)}
                value={LastName}
                placeholder="Achternaam"
                errorMessage="Vul hier je achternaam in, je naam moet minimaal twee letters bevatten."
                pattern="[0-9a-zA-Z ]{1,}"
                type="text"
            />
            <TextInput
                labelName="Email"
                inputName="email"
                onChange={(e) => setEmail(e.target.value)}
                value={Email}
                placeholder="Email"
                errorMessage="Vul hier je email in"
                pattern={undefined}
                type="email"
            />
            <TextInput
                labelName="Telefoonnummer"
                inputName="phone"
                onChange={(e) => setPhone(e.target.value)}
                value={Phone}
                placeholder="Telefoonnummer"
                errorMessage="Vul hier je Telefoonummer in, gebruik alleen getallen, geen + of -"
                pattern="[0-9]{10,}"
                type="text"
            />
            <PasswordInput labelName="Wachtwoord" value={Password} inputName="password" onChange={(e) => setPassword(e.target.value)} errorMessage="Ongeldig wachtwoord, je wachtwoord moet minimaal 10 tekens lang zijn" pattern=".{10,}" />
            <CheckBoxInput labelName="Admin" inputName="admin" value="yes" checked={adminRole} setChecked={setAdminRol}/>
            {deleteConfirm &&
                <div className="">
                    Weet je zeker dat je {FirstName} {LastName} wilt verwijderen?
                </div>
            }
            {deleteConfirm &&
                <div className="grid grid-cols-1 gap-0 md:grid-cols-2">
                    <div className="flex justify-center">
                        <DefaultButton onClick={deleteUser} content="JA" />
                    </div>
                    <div className="flex justify-center">
                        <DefaultButton onClick={() =>(setDeleteConfirm(false))} content="NEE" />
                    </div>
                </div>
            }
        </BaseModal>
    );
}
export default EditUserModal
